import * as React from 'react';

import type { FaqModuleItem } from '@coursera-web/cds-labs';
import type { CmlContent } from '__generated__/graphql-types-do-not-use';

import { CML, toPlainText } from 'bundles/cml';
import type { FaqFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/SharedCommonEntitiesFragments';
import convertToCmlContent from 'bundles/unified-description-page-common/utils/convertToCmlContent';

const convertCmlFaqs = (faqs: Array<FaqFragment>) => {
  const convertedFaqs: FaqModuleItem[] = [];
  const textFaqs: { question: string; answer: string }[] = [];

  faqs.forEach((faq) => {
    const question = toPlainText(convertToCmlContent(faq.question as CmlContent)) || '';

    convertedFaqs.push({
      question,
      answer: <CML cml={faq.answer as CmlContent} />,
    });

    textFaqs.push({
      question,
      answer: toPlainText(convertToCmlContent(faq.answer as CmlContent)) || '',
    });
  });

  return { convertedFaqs, textFaqs };
};

export default convertCmlFaqs;
